import { AApi } from "@/service/AApi";
const API = new AApi({ url: "product-add" });
export default API;
